import { MovementPatternDtlEntity } from "./MovementPatternDtlEntity"

export interface MovementPatternEntity {
    id: number,
    priority?: number | null,
    tempPriority?: number | null,
    noOfLift?: number | null,
    chargeOnCompany?: string | null,
    patternType?: string | null,
    activeInd?: string | null,
    movementDetails: MovementPatternDtlEntity[],

    [key: string]: string | boolean | null | Object | undefined
}

export const EMPTY_MOVEMENT_PATTERN_ENTITY: MovementPatternEntity = {

    id: 0,
    priority: null,
    tempPriority: null,
    noOfLift: null,
    chargeOnCompany: null,
    patternType: null,
    activeInd: 'Y',
    movementDetails: [],
}